import CaseCreationSelectPharmacy from '@brands/Dashboard/PatientForms/StaffCaseCreation/SelectPharmacy/SelectPharmacy';
import { UserRoleName } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import { isUnifiedStaffCaseIntakeRole } from '@brands/Utils/reviewProfileBasePath';
import React from 'react';

import { useAppSelector } from '../../../../hooks/useReduxHook';
import SelectPharmacy from './SelectPharmacy';

/** Patient intake vs unified staff case-creation (admin / collector / care advisor). */
const SelectPharmacyRoute: React.FC = () => {
  const { userInfo } = useAppSelector(selectAuth);
  if (!userInfo) {
    return null;
  }
  if (userInfo.role.name === UserRoleName.Patient) {
    return <SelectPharmacy />;
  }
  if (isUnifiedStaffCaseIntakeRole(userInfo.role.name)) {
    return <CaseCreationSelectPharmacy />;
  }
  return <SelectPharmacy />;
};

export default SelectPharmacyRoute;
